export default {"timer":"CFJ-f"};